const getters = {
  username: state => state.user.username,
  name: state => state.user.name,
  department: state => state.user.department,
  role: state => state.user.role,
  purviews: state => state.user.purviews,
  workshops: state => state.user.workshops
}
export default getters
